import { loadStripe, Stripe, StripeError } from "@stripe/stripe-js";

const key = (window as any).stripePublishableKey;
const stripePromise: Promise<Stripe | null> = key ? loadStripe(key) : Promise.resolve(null);

export async function handleStripeErrors<T extends { error?: StripeError }>(stripeCall: () => Promise<T>) {
    const { error, ...rest } = await stripeCall();
    if (error) {
        throw new Error(error.message);
    }
    return rest;
}

export async function getStripe() {
    return await stripePromise;
}
